import { V2Button, V2Switch, V2Tooltip } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { SearchBar } from "app/components/SearchBar";
import { useHasScopePermission } from "app/hooks";
import PlusIcon from "assets/icons/plus.svg?react";

interface Props {
  /** Expanded state of group rows */
  isExpanded: boolean;
  /** Expanded state change handler */
  onExpandedChange: (expanded: boolean) => void;
}

export function GroupsActionBar({ isExpanded, onExpandedChange }: Props) {
  const navigate = useNavigate();

  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <SearchBar
          className="w-[25rem]"
          onSearch={undefined}
          title="Search groups"
        />
        <V2Tooltip
          title={
            hasSystemEditPermission
              ? ""
              : "You need system edit permissions to add a group"
          }
          asChild
        >
          <span>
            <V2Button
              IconLeft={<PlusIcon height={20} width={20} />}
              isDisabled={!hasSystemEditPermission}
              onPress={() => navigate("add")}
              variant="primary"
            >
              Add Group
            </V2Button>
          </span>
        </V2Tooltip>
      </div>

      <div className="mb-4 rounded-xs border border-outline-decorative p-md">
        <div className="flex w-full items-center gap-1">
          <V2Switch isSelected={isExpanded} onChange={onExpandedChange}>
            Expand all
          </V2Switch>
        </div>
      </div>
    </div>
  );
}
